export const maskSwitchStyle = {
	wrapper: {
		display: 'flex',
		justifyContent: 'space-around',
		alignItems: 'center',
		position: 'relative',
		maxWidth: '280px',
		height: '44px',
		width: '100%',
		borderRadius: '30px',
		background: 'var(--neutral-50)',
	} as any,

	mask: {
		position: 'absolute',
		left: '4px',
		top: '4px',
		width: '100%',
		marginRight: '8px',
		maxWidth: '132px',
		height: '36px',
		borderRadius: '20px',
		background: '#fff',
		boxShadow: 'var(--box-shadow--1)',
		transition: 'all 0.5s ease',
		transform: 'translateX(140px)',
	},

	activeMask: {
		transform: 'translateX(0)',
	},

	button: {
		color: 'var(--neutral-300)',
		fontSize: '16px',
		fontWeight: 400,
		borderRadius: '20px',
		width: '100%',
		minWidth: '124px',
		padding: '0 12px',
	},

	buttonActive: {
		background: 'unset',
		color: 'var(--primary-500)',
		fontSize: '16px',
		fontWeight: 700,

		'&:hover': {
			opacity: 0.9,
		},
	},
};
